import { ApolloClient } from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { setContext } from "apollo-link-context";

const httpLink = createHttpLink({
  uri: `${process.env.VUE_APP_API_URL}graphql`
});

const authLink = setContext((_, { headers }) => {
  const token =
    JSON.parse(localStorage.getItem("cardinal-user") || "{}").token || "";
  return {
    headers: token
      ? {
          ...headers,
          Authorization: `${token}`
        }
      : { ...headers }
  };
});

const cache = new InMemoryCache();

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache
});
